<template>
  <v-expansion-panels inset>
    <v-expansion-panel class="elevation-2">
      <v-expansion-panel-header>
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="title black--text font-weight-bold">{{ item.title }}</v-list-item-title>
            <v-list-item-subtitle class="caption">
              By
              <!--  -->
              <v-menu open-on-hover right offset-y>
                <template v-slot:activator="{ on }">
                  <span class="blue--text darken-2" v-on="on">{{ item.user.username }}</span>
                </template>
                <v-card>
                  <v-list>
                    <v-list-item>
                      <v-list-item-avatar>
                        <img :src="profileUrl" :alt="item.user.username" />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.user.firstName + " " + item.user.lastName}}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.user.proffession }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>
                </v-card>
              </v-menu>
              <!--  -->
            </v-list-item-subtitle>
          </v-list-item-content>
          <!--  -->
          <v-row justify="center">
            <v-chip
              class="ma-2"
              :color="myVote.background"
              label
              text-color="white"
              v-if="item.user._id != user._id"
            >
              <v-icon :color="myVote.color" left>{{ myVote.icon }}</v-icon>
              {{ myVote.value}}
            </v-chip>
            <v-chip
              v-else
              class="ma-2"
              color="black darken-4"
              outlined
              label
              text-color="white"
            >
              <v-icon left class="black--text">mdi-fingerprint</v-icon>
              <span class="black--text">Your Idea</span>
            </v-chip>
          </v-row>
          <!--  -->
          <v-row align="center" justify="end">
            <div class="mx-3">
              <span>{{ item.upVote }}</span>
              <v-icon color="green">mdi-arrow-up</v-icon>
            </div>
            <div class="mr-5">
              <v-icon color="error">mdi-arrow-down</v-icon>
              <span>{{ item.downVote }}</span>
            </div>
          </v-row>
        </v-list-item>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-col>
          <div class="mb-5 pb-5" v-if="item.user._id != user._id">
            <v-row align="center" justify="center">
              <v-btn
                class="mx-2 elevation-15"
                fab
                outlined
                dark
                :disabled="voteValue == true"
                large
                color="green"
                @click="voteValue = true"
              >
                <v-icon dark>mdi-thumb-up</v-icon>
              </v-btn>
              <span class="mx-5">{{ item.upVote }}</span>
              <v-divider vertical class="mx-2"></v-divider>
              <span class="mx-5">{{ item.downVote }}</span>

              <v-btn
                class="mx-2 elevation-15"
                fab
                outlined
                dark
                :disabled="voteValue == false"
                large
                color="secondary"
                @click="voteValue = false"
              >
                <v-icon dark>mdi-thumb-down</v-icon>
              </v-btn>
            </v-row>
            <v-row justify="center" style="margin-top: 50px">
              <v-btn
                color="error"
                outlined
                class="elevation-10"
                :disabled="voteValue == null"
                @click="voteValue = null"
              >
                <v-icon>mdi-cancel</v-icon>
                <span>Remove Vote</span>
              </v-btn>
            </v-row>
          </div>

          <div>
            <span>{{ item.description }}</span>
          </div>
        </v-col>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      //   voteValue: null
      voteObj: {
        id: this.item._id,
        vote: this.item.hasVoted,
        poll_id: this.item.poll,
        hasVoted: this.item.hasVoted
      }
    };
  },
  watch: {
    voteValue(val) {
      this.vote(this.voteObj);
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    voteValue: {
      get() {
        if (this.voteObj.vote == true) {
          return true;
        } else if (this.voteObj.vote == false) {
          return false;
        } else return null;
      },
      set(value) {
        this.voteObj.vote = value;
      }
    },
    myVote() {
      if (this.voteValue == true) {
        return {
          value: "Approved Idea",
          background: "green lighten-1",
          icon: "mdi-thumb-up-outline",
          color: "white"
        };
      } else if (this.voteValue == false) {
        return {
          value: "Disapproved Idea",
          background: "red lighten-2",
          icon: "mdi-thumb-down-outline",
          color: "white"
        };
      } else {
        return {
          value: "Unvoted Idea",
          background: "grey",
          icon: "mdi-hand",
          color: "white"
        };
      }
    },
    profileUrl() {
      if (this.item.user.sex == "Male") {
        if (this.item.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/m.jpg");
        } else if (this.item.user.proffession == "Developer") {
          return require("@/assets/images/DV/m.png");
        } else return require("@/assets/images/ST/m.png");
      } else {
        if (this.item.user.proffession == "Software Engineer") {
          return require("@/assets/images/SE/f.jpg");
        } else if (this.item.user.proffession == "Developer") {
          return require("@/assets/images/DV/f.png");
        } else return require("@/assets/images/ST/f.png");
      }
    }
  },
  methods: {
    ...mapActions("idea", ["vote"])
  }
};
</script>